import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ServiceService } from '../service.service';
import { ModalController, IonInfiniteScroll, Platform } from '@ionic/angular';
import { PostsModalPage } from '../posts-modal/posts-modal.page';
import { ModalImagesPage } from '../modalImages/modalImages.page';
import { LoadingController } from '@ionic/angular';
import { AlertController } from '@ionic/angular';
import { DomSanitizer } from '@angular/platform-browser';
import { StreamingVideoOptions, StreamingMedia } from '@ionic-native/streaming-media/ngx';
import { EmailComposer } from '@ionic-native/email-composer/ngx';

@Component({
  selector: 'app-postsbyuser',
  templateUrl: './postsbyuser.page.html',
  styleUrls: ['./postsbyuser.page.scss', '../../assets/scss/styles.scss'],
})

export class PostsbyuserPage implements OnInit {
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  DEFAULT_PAGE = 1;

  iduser: any;
  roleId: number;
  
  forumImageUrl: string;
  listPosts: any;
  listPostsTemp: any;
  like: any;
  searchbar: string;
  detailString: string;
  imageUrl: string;
  search: string;
  listaPublicacion: any = [];
  contador: number = 0 ;
  indice: number = 0;
  lengthListPublic: number;
  idUserFromPost;
  actualPublicidadIndex:any;
  isWeb:boolean = false;
  isMovil:boolean = false;

  constructor(
    private activatedRoute: ActivatedRoute,
    public services: ServiceService,
    public modalController: ModalController,
    private loadingController: LoadingController,
    private alertCtrl: AlertController,
    private streamingMedia: StreamingMedia,
    public sanitizer: DomSanitizer,
    private router: Router,
    private platform: Platform,
    private emailComposer: EmailComposer,
  ) {
    JSON.stringify(localStorage.setItem('urls', this.router.url));
    this.iduser = JSON.parse(localStorage.getItem('idUser'));
    this.roleId = JSON.parse(localStorage.getItem('roleId'));
  }

  async ngOnInit() {
    // console.log("async ngOnInit()");
    this.isMovil = this.services.isMovil();
    this.isWeb = !this.isMovil;
    this.idUserFromPost = this.activatedRoute.snapshot.paramMap.get('idUser');
    // console.log(this.idUserFromPost);

    //this.listPublic();
    this.actualPublicidadIndex = 0;
    this.getPromosByCategory();
  }

  async ionViewWillEnter() {
    let forum = JSON.parse(localStorage.getItem("forum"));
    this.forumImageUrl = forum.imageUrl;

    const loading = await this.loadingController.create({
      message: 'Cargando posts…', duration: 4000
    });
    await loading.present();
    await this.loadPosts(null);
    await loading.dismiss();
  }

  async loadPosts(event) {
    this.listPosts =[];
    this.DEFAULT_PAGE=1;

    JSON.stringify(localStorage.setItem('idposts', '1'));
    this.servicioBase(event);
  }
  async loadPostsModal() {
    const loading = await this.loadingController.create({
      message: 'Cargando posts…'
    });
    await loading.present();
    await this.loadPosts(null);
    await loading.dismiss();
  }
  async doRefreshScroll(event) {
    JSON.stringify(localStorage.setItem('idposts', '1'));
    this.servicioBase(event);
  }
  async doRefresh(event) {
    this.searchbar="";
    this.listPosts =[];
    this.DEFAULT_PAGE=1;

    JSON.stringify(localStorage.setItem('idposts', '1'));
    this.servicioBaseRefresh(event);
  }
  async openModal() {
    const modal = await this.modalController.create({
      component: PostsModalPage,
      componentProps: { forumId: '1' }
    });
    modal.onDidDismiss().then(data => {
      this.loadPostsModal();
    });
    return await modal.present();
  }
  async toggleInfiniteScroll() {
    this.infiniteScroll.disabled = await !this.infiniteScroll.disabled;
  }
  async openModalImages(images, current) {
    const modal = await this.modalController.create({
      component: ModalImagesPage,
      cssClass: 'my-custom-class',
      componentProps: {
        // tslint:disable-next-line: object-literal-key-quotes
        'images': images,
        // tslint:disable-next-line: object-literal-key-quotes
        'current': current
      }
    });
    return await modal.present();
  }

  getElapsedTime(date) {
    return this.services.getElapsedTime(date);
  }

  async presentAlert(mensaje) {
    const alert = await this.alertCtrl.create({
      header: 'Like!',
      message: mensaje,
      buttons: ['OK'],
    });

    await alert.present();
    const result = await alert.onDidDismiss();
  }

  async likePostUser(post, index) {
    this.listPosts[index].likesPostsUsersCount++;
    // tslint:disable-next-line: no-unused-expression
    this.listPosts[index].likesPostsUser === true;

    this.services.postLikePostsUser(post.id).subscribe(
      async (data) => {
        // await this.servicioBase();
        const response = data;
        this.listPosts[index].likesPostsUsers = response[0].likesPostsUsers;
        this.listPosts[index].likesPostsUsersCount = response[0].likesPostsUsersCount;
        this.listPosts[index].likesPostsUser = true;
        this.postNotificationLike('notification1', post.detail, post.user.id);
        this.postNotificationLikePointsEarned(post.user.id, response[0].pointsEarned.pointsWin);
      },
      (error) => {
        console.log(error);
        if (this.listPosts[index].likesPostsUsersCount > 0) {
          this.listPosts[index].likesPostsUsersCount--;
          this.listPosts[index].likesPostsUser = false;
        }
      }
    );
  }

  async likePostUserDelete(postId, index) {
    if (this.listPosts[index].likesPostsUsersCount > 0) {
      this.listPosts[index].likesPostsUsersCount--;
      this.listPosts[index].likesPostsUser = false;
    }

    await this.services.postLikePostsUserDelete(postId).subscribe(
      async (data) => {
        const post = data;
        this.listPosts[index].likesPostsUsers = post[0].likesPostsUsers;
        this.listPosts[index].likesPostsUsersCount = post[0].likesPostsUsersCount;
        this.listPosts[index].likesPostsUser = false;
      },
      (error) => {
        console.log(error);
        this.listPosts[index].likesPostsUsersCount++;
        this.listPosts[index].likesPostsUser = true;
      }
    );
  }

  async servicioBase(event) {
    this.idUserFromPost = this.activatedRoute.snapshot.paramMap.get('idUser');

    this.services.getPostsByUser(this.idUserFromPost, this.DEFAULT_PAGE).subscribe(
      async (data: any) => {
        this.listPostsTemp= await data?.posts;
        if(this.listPosts === undefined){
          this.listPosts = await data?.posts;
          this.listPosts =[];
        }else
        if(this.DEFAULT_PAGE==1){
          this.listPosts =await data?.posts;
          this.listPosts =[];
        }
        this.listPosts = [...this.listPosts,...this.listPostsTemp];
        this.actualPublicidadIndex = 0;
        this.listPosts = this.listPosts.map((item,index) => ({
          ...item,
          truncateString: (item.detail.length>250?true:false),
          showMore:false,
          isBannerVisible : index % 5 == 0 && index != 0 ? true: false,
          dataPublicidad: this.getInfoBanner(index+1)
        }));
        if(event!=null){
          await event.target.complete();
          if (this.listPostsTemp.length < 10) {
            event.target.disabled = true;
          }

        }
        this.DEFAULT_PAGE++;
      },
      (error) => {
        // console.log(error);
      }
    );
  }

  public getInfoBanner(indexPost:number){
    if (!Array.isArray(this.listaPublicacion) || this.listaPublicacion.length == 0) {
      this.actualPublicidadIndex = 0;
      return null;
    } else if(indexPost%5 == 0) {
      let objeto = this.listaPublicacion[this.actualPublicidadIndex];
      this.actualPublicidadIndex = this.actualPublicidadIndex == this.listaPublicacion.length - 1 ? 0 : this.actualPublicidadIndex + 1;
      return objeto;
    }else{
      return null;
    }
  }
  
  async servicioBaseRefresh(event) {
    this.idUserFromPost = this.activatedRoute.snapshot.paramMap.get('idUser');

    this.services.getPostsByUser(this.idUserFromPost, this.DEFAULT_PAGE).subscribe(
      async (data) => {
        this.listPostsTemp= await data;
        //this.dataPostsCNCTemp =  {...data};
        if(this.listPosts === undefined){
          this.listPosts = await data;
          this.listPosts =[];
        }else
        if(this.DEFAULT_PAGE==1){
          this.listPosts =await data;
          this.listPosts =[];
        }
        this.listPosts = [...this.listPosts,...this.listPostsTemp]
        await event.target.complete();
        await this.toggleInfiniteScroll();
      },
      (error) => {
        console.log(error);
      }
    );
  }

  async searchPosts(q: string) { 
    if(q==""){
      await this.toggleInfiniteScroll();
      await this.loadPostsModal();
    }
    else{
      const loading = await this.loadingController.create({
        message: 'buscando post...'
      });
      await loading.present();
      (await this.services.getFilterPostsByForum('1',q)).subscribe(
        async (data) => {
          this.listPosts = data;
          await this.toggleInfiniteScroll();
          await loading.dismiss();
        },
        async (error) => {
          console.log(error);
          await loading.dismiss();
        }
      );
    }
    
  }
  async clearSearch(e) {
    await this.toggleInfiniteScroll();
    await this.loadPostsModal();
  }
  plays(item) {
    console.log(item);
    const options: StreamingVideoOptions = {
        successCallback: () => { console.log('Video played'); },
        errorCallback: (e) => { console.log('Error streaming'); },
        orientation: 'landscape',
        shouldAutoClose: true,
        controls: true
      };
    this.streamingMedia.playVideo(`'${item}'`, options);
  }

  async deletePost(postId, index) {
    const alert = await this.alertCtrl.create({
      message: 'Si borras un post con respuestas de otros participantes, sus puntos se te restarán a ti ¿Seguro de eliminar este posts?',
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {
          }
        }, {
          text: 'Aceptar',
          handler: () => {
            this.services.deletePosts(postId).subscribe( (res) => {
              this.listPosts.splice(index, 1);
            }, error => console.error(error));
          }
        }
      ]
    });
    await alert.present();
  }

  // Envio de notificación al usuario al hacer un like
  async postNotificationLike(notification1, details, userid){
    this.detailString = details;
    this.imageUrl = localStorage.getItem("imageUrl");
    if(this.detailString.length > 25){
      this.detailString = localStorage.getItem("completeName") + ' le dió like a "' + this.detailString.substr(0, 25) + '..."';
    }
    else{
      this.detailString = localStorage.getItem("completeName") + ' le dió like a "' + details + '"';
    }
    (await this.services.postNotifications(notification1, this.detailString, userid, this.imageUrl)).subscribe(
      async (data) => {
      },
      (error) => {
        console.log(error);
      }
    );
  }

  async postNotificationLikePointsEarned(userid,points=0){
    if(points>0){
      this.imageUrl = localStorage.getItem("imageUrl");
      (await this.services.postNotifications('notification1', 'Sumaste '+points+' puntos por like recibidos.', userid, this.imageUrl)).subscribe(
        async (data) => {},
        (error) => {}
      );
    }
  }

async listPublic() {
    await this.services.getPublic().subscribe( (res) => {
      this.listaPublicacion = res;
      this.lengthListPublic = Object.keys(res).length;
    });
  }

  public async getPromosByCategory(){
    /* 
      1	Bienvenido
      2	Promociones
      3	Posts    
    */

   const loading = await this.loadingController.create({
    message: 'Espere por favor ...', duration: 6000
  });

  await loading.present();

   (await this.services.getPromosByZone(3)).subscribe(
     (response : any ) => {
      loading.dismiss();
      if (Array.isArray(response) ) {
        this.listaPublicacion = response;
        this.lengthListPublic = Object.keys(response).length;
        //console.log(this.listaPublicacion);
        
      } else {
        //error al obtener los datos
        this.listaPublicacion = new Array();
        this.services.showAlert("Ha ocurrido un error al obtener las promociones.");
      }
     },(error : any ) => {
      loading.dismiss();
       this.services.showAlert("Ha ocurrido un error al obtener las promociones.");
     });
  }

  public getNameImage(){
    if(!Array.isArray(this.listaPublicacion)){
      this.actualPublicidadIndex = 0;
      return 'assets/images/imgNotFound.jpeg';
    }else{
      let url = this.listaPublicacion[this.actualPublicidadIndex]?.resourceUrl;
      this.actualPublicidadIndex = this.actualPublicidadIndex < (this.listaPublicacion.length - 1) ? (Number(this.actualPublicidadIndex) + 1) : 0 ;
      if(!url) return 'assets/images/imgNotFound.jpeg';
      return String(url) + '?123456789'; 
    }
    

  }  

  async threads(postId, userId, detail){
    this.router.navigate(['/threads',postId,userId,detail]);
  }

  public async openEmailDialog(item_: any){
    let item: any = new Object();
    item = item_;
    await this.services.savePromotionMetric([item]);
    if(item?.bannerUrl){
      //window.open(item?.bannerUrl, '_system', 'location=yes');
      if(!this.isWeb)
        this.openFrame(item?.bannerUrl);
      else if(this.isWeb)
        window.open(item?.bannerUrl, "_blank");
      return;
    }

    const email = {
      to: String(item.email),
      cc: [],
      attachments: [],
      subject: String(item.mailAffair),
      body: String(item.mailBody),
      isHtml: false,
      app: "correo"
    };
    
    this.emailComposer.open(email);
  }

  public openFrame(url : any ){

    if (this.platform.is('ios')) {
      var ifrm = document.createElement('iframe');
      ifrm.setAttribute('id', 'ifrm'); // assign an id
  
      // to place before another page element
      var el = document.getElementById('iframeHolder');
      el.parentNode.insertBefore(ifrm, el);
  
      // assign url
      ifrm.setAttribute('src', url);
      ifrm.setAttribute('width', '0px');
      ifrm.setAttribute('height', '0px');
    } else {
      window.open(url, '_system', 'location=yes')
    }

  }
}
